import { useMemo } from 'react'

import { useConnect } from 'redux-bundler-hook'

import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT } from '~/src/Lib/Utils'

const displayName = 'Task/shared/utils'
const logger = createLogger(displayName)

export const useAssigneeOptions = (assigneesList, userSearch) => {
  const connectedProps = useConnect('selectFacilityMemberships', 'selectUsers')
  const { facilityMemberships: memberships, users } = connectedProps

  const staffMembershipOptions = useMemo(() => Object.values(memberships ?? EMPTY_OBJECT).map(membership => ({
    value: membership.id,
    label: users[membership.user].fullName
  })), [memberships, users])

  const staffOptions = useMemo(() => staffMembershipOptions
    .filter(staffMember => {
      if (assigneesList?.some(assignee => assignee.membership === staffMember.value)) return false
      return !userSearch || staffMember.label.toLowerCase().includes(userSearch.toLowerCase())
    }), [assigneesList, staffMembershipOptions, userSearch])
  return staffOptions
}
